import styled from "styled-components";
import { colors } from "../../../assets";

export const StatsCardContainer = styled.article`
  .stats-card {
    &-title {
      min-height: 36px;
    }

    &-content {
      display: flex;
      align-items: center;
      gap: 15px;

      &-number {
        font-weight: 500;
        font-size: 100px;
        
        p {
          color: ${colors["SC-001-100"]};
          min-height: 100px;
          min-width: 60px;
        }
      }

      &-action {
        button {
          width: 175px;
        }
      }
    }
  }
`;
